
import {Component, Vue} from "vue-property-decorator";
import {INotification} from "@/interfaces/notification.interface";
import {IProfilePayment, ProfileNoticeData} from "@/modules/Profile/interfaces/profile-payment.interface";
import {MessageType} from "element-ui/types/message";
import {IProfile} from "@/modules/Profile/interfaces/profile.interface";
import ProfilePaymentCard from "@/modules/Profile/components/payment/ProfilePaymentCard.vue";
import AppInputMoney from "@/components/AppInputMoney.vue";
import {paymentResource} from "@/modules/Profile/resources/payment.resource";
import AppSwitch from "@/components/AppSwitch.vue";
import LastPayBlock from "@/modules/Profile/components/payment/LastPayBlock.vue";
import {bus} from "@/plugins/bus";
import {IBalance} from "@/modules/Payment/interfaces/balance.interface";
import SelectCars from "@/modules/Profile/components/payment/SelectCars.vue";

@Component({
  components: {
    SelectCars,
    LastPayBlock,
    AppSwitch,
    AppInputMoney,
    ProfilePaymentCard
  }
})
export default class ProfilePayment extends Vue {
  $refs: any;
  dataReady = false;
  cardList: IProfilePayment.ICardData[] = [];
  paymentSettings = {
    bankAutoPayFlag: false,
    bankCardLimitSum: 3000,
    usedCardId: null,
  };
  formModel = {
    bankAutoPayFlag: false,
    bankCardLimitSum: 3000,
    usedCardId: null,
  };
  cashCard: IProfilePayment.ICardData = {
    id: -1,
    cashCard: true,
    dftFlag: false,
    cardName: '',
    bankName: '',
  };
  lastPay = null;
  getPaysInterval = null;
  getPaysTimer = 0;

  get activeCard() {  return this.cardList.find((card) => card.dftFlag); }
  get hasChanges() { return Object.keys(this.paymentSettings).some(key => this.paymentSettings[key] !== this.formModel[key]);}

  async created() {
    await this.checkRouteNotice();
    await this.getCardList();
  }

  async mounted() {
    bus.$on(IBalance.Events.OpenPaymentResultPage, ({type, status, orderUid}) => {
      if (type === 'saveCard' && status === 'success') {
        this.checkCardAdd(orderUid);
      }
    });
  }

  async checkRouteNotice() {
    let query = this.$route.query;
    if (!!this.$route.query) {
      if (query[INotification.RouteKey.Notice]) {
        const noticeKey = IProfilePayment.NoticeKey;
        const noticeType = query[INotification.RouteKey.Notice];
        const noticeStatus = query[noticeKey.Status];
        // @ts-ignore
        const noticeData = ProfileNoticeData[noticeType][noticeKey.Status][noticeStatus];
        if (noticeData) {
          this.$notify({
            title: noticeData.title,
            message: noticeData.text,
            type: noticeStatus as MessageType,
          });
          this.$router.replace({ query: {}, hash: `#${IProfile.PageTab.Payment}` });
        }
      }
    }
  }

  async getCardList() {
    let response = await paymentResource.getCardList();
    this.cardList = response.cardList;
    this.lastPay = response.lastPay;
    let usedCardId = response.paymentSettings.bankAutoPayFlag && this.activeCard ? this.activeCard.id : this.cashCard.id;

    this.paymentSettings = {...response.paymentSettings, usedCardId };
    this.formModel = {...this.paymentSettings, usedCardId };

    this.cashCard.dftFlag = usedCardId === this.cashCard.id;
    this.cardList.sort((a, b) => a.dftFlag ? -1 : 1);
    let cashIndex = this.formModel.bankAutoPayFlag ? 1 : 0;
    this.cardList.splice(cashIndex, 0, this.cashCard);

    this.dataReady = true;
  }

  async addNewCard() {
    let carNumber = this.$route.params?.carNumber;
    await this.$store.dispatch('confirm/open', {
      title: 'Подтвердите действие',
      text: `Чтобы добавить карту, нужно убедиться, что она работает.<br>
             Мы спишем 1 рубль, а затем вернем обратно.<br><br>
             <span class="color--orange">В форме банка нажмите «Оплатить картой».</span><br><br>
             Введите данные карты и подтвердите платеж.`,
      cancel: {
        text: 'Отменить',
      },
      confirm: {
        text: 'Ок',
        action: async () => {
          await paymentResource.addNewCard({carNumber});
        },
      },
    });
  }

  async setDefaultCard(cardIndex: number, cardId: number) {
    this.cardList.forEach((item, index) => item.dftFlag = index === cardIndex);
    this.formModel.usedCardId = cardId;
    this.formModel.bankAutoPayFlag = cardId !== this.cashCard.id;
  }

  async deleteCard(cardIndex: number, cardId: number) {
    let { success } = await paymentResource.removeCard(cardId);
    if (success) {
      if (this.activeCard && this.activeCard.id === cardId) {
        let cashIndex = this.cardList.findIndex(card => card.cashCard);
        await this.setDefaultCard(cashIndex, this.cashCard.id);
        await this.saveChanges();
      }
      this.cardList.splice(cardIndex, 1);
      this.$notify({title: 'Успешно', message: 'Карта отвязана', type: 'success'});
    }
  }

  async setDefaultForm(revert = false) {
    Object.keys(this.paymentSettings).forEach(key => {
      if (revert) Vue.set(this.formModel, key, this.paymentSettings[key]);
      else Vue.set(this.paymentSettings, key, this.formModel[key]);
    });
    if (this.$refs.bankCardLimitSum) this.$refs.bankCardLimitSum.forceUpdate();
  }

  async saveChanges() {
    if (this.formModel.usedCardId !== -1 && this.paymentSettings.usedCardId !== this.formModel.usedCardId) {
      await paymentResource.setDefaultCard(this.formModel.usedCardId);
    }
    let { success } = await paymentResource.setPaymentSettings(this.formModel);
    if (success) {
      this.setDefaultForm();
      this.$notify({title: 'Успешно', message: 'Все изменения сохранены', type: 'success'});
    }
  }

  async changeTabAction() {
    if (this.hasChanges) await this.saveChanges();
  }

  async checkCardAdd(orderUid: string) {
    let response = await paymentResource.checkCardAdd(orderUid);
    if (response.response && response.response.data.result.paymentState === 'DEPOSITED') {
      this.getCardList();
      return;
    }

    this.getPaysTimer = 0;
    this.$notify({
      title: 'Ожидайте',
      message: 'Банк пока не подтвердил добавление карты. Когда придет ответ от банка в списке появится добавленная карта',
      type: 'warning'
    });
    this.getPaysInterval = setInterval(async () => {
      let response = await paymentResource.checkCardAdd(orderUid);
      if (response.response && response.response.data.result.paymentState === 'DEPOSITED') {
        clearInterval(this.getPaysInterval);
        this.getCardList();
        this.$notify({
          title: 'Успешно',
          message: 'Банк подтвердил добавление карты',
          type: 'success'
        });
      }
      else {
        this.getPaysTimer += 3;
        if (this.getPaysTimer >= 60) {
          this.$notify({
            title: 'Данные не обновились',
            message: 'Банк пока не подтвердил добавление карты. Попробуйте зайти в этот раздел позже',
            type: 'error'
          });
          clearInterval(this.getPaysInterval);
        }
      }
    }, 3000);
  }

  destroyed() {
    bus.$off(IBalance.Events.OpenPaymentResultPage);
    if (this.getPaysInterval) clearInterval(this.getPaysInterval);
  }
}
